import { Injectable, inject } from '@angular/core';
import { IModelState } from '@partners/api';
import { IRemoteError } from '@partners/errors';
import { ContactStore } from '@partners/state';
import { isNotEmpty } from '@partners/utils';
import { PolicyService } from '../../process';

@Injectable({
  providedIn: 'root'
})
export class ContactFacade {
  private _policyService = inject(PolicyService);
  private _contactStore = inject(ContactStore);

  contactModel$$ = this._contactStore.model$$;

  constructor() {}

  /**
   * @description
   * there are some scenarios where contact form should display a club membership input field. the field's
   * state (hidden | required) is resolved here and registered into the contact store. these scenarios are
   * exclusive to the card process. the membership field's state should to be resolved in the following cases:
   * scenario 1: on contact form first load
   * scenario 2: on contact form submit failure with severities (W_0024 | W_0038 | W_0039)
   *
   * @param error an http remote error will be passed in on scenario 2 only
   */
  resolveClubMembershipState = (error?: IRemoteError): void => {
    const membershipState: IModelState = {
      hidden: true,
      required: false
    };

    const severityCode = error?.severity?.code;

    if (!this._policyService.businessPartner$$()) {
      return;
    }

    const { isClubMemRequired, isClubMemberMustField } = this._policyService.businessPartner$$();

    if (severityCode) {
      const isVisibleAndOptional =
        isClubMemRequired === 3 &&
        isNotEmpty(isClubMemberMustField) &&
        !isClubMemberMustField &&
        severityCode &&
        ['W_0038', 'W_0039'].indexOf(severityCode) != -1;

      const isVisibleAndRequired = isClubMemRequired === 4 && isClubMemberMustField && severityCode === 'W_0024';

      if (isVisibleAndOptional || isVisibleAndRequired) {
        Object.assign(membershipState, { hidden: false, required: isVisibleAndRequired });
      }
    } else {
      const isVisible = isClubMemRequired === 2 && isNotEmpty(isClubMemberMustField) && !isClubMemberMustField;
      if (isVisible) {
        Object.assign(membershipState, { hidden: false });
      }
    }

    this._contactStore.dispatchUpdateClubMembershipState(membershipState);
  };
}
